import React from 'react';
import { Button, ButtonProps } from 'reactstrap';
import {
  LoadingSpinnerIcon,
  PropTypes as LoadingSpinnerIconPropTypes,
} from '../LoadingSpinnerIcon';

interface PropTypes extends ButtonProps {
  isLoading: boolean;
  loadingSpinnerProps?: LoadingSpinnerIconPropTypes;
  children: React.ReactNode;
}

export function LoadingButton(props: PropTypes) {
  return (
    <Button {...props} disabled={props.disabled ?? props.isLoading}>
      {props.isLoading && (
        <LoadingSpinnerIcon className={'me-2'} {...props.loadingSpinnerProps} />
      )}
      {props.children}
    </Button>
  );
}
